import React from 'react';
import { Typography, Box, Divider } from '@mui/material';
import debounce from 'lodash.debounce';

import { RouteTitleStyle } from './style';
import { getTitleReactEle } from 'pages/utils';

export function handleMenu({ routes, shop }) {
  return routes.reduce((arr, route = {}) => {
    const { children, getTitle } = route;
    const name = (
      <Box component="span" sx={RouteTitleStyle}>
        {route.name}
        <Divider />
      </Box>
    );
    let checkTitleRepeat = [];
    if (children && shop[children.key])
      arr.push({
        ...route,
        name,
        children: (shop[children.key] || []).reduce((arr, child) => {
          const { title, id } = child;

          if (getTitle) {
            const newTitle = getTitle(title); // for category
            if (checkTitleRepeat.includes(newTitle)) return arr;
            checkTitleRepeat.push(newTitle);
          }

          const childName = getTitleReactEle({ title });

          arr.push({
            key: id,
            path:
              typeof children.path === 'string'
                ? children.path
                : children.path(child),
            name: (
              <Typography
                sx={RouteTitleStyle}
                variant="body3"
                color="menu.secondary"
              >
                {childName}
              </Typography>
            ),
          });
          return arr;
        }, []),
      });
    else arr.push({ ...route, name });
    return arr;
  }, []);
}
// debounce can fix iphone safari resize bug
export const setBodyHeight = debounce(() => {
  const dom = document.querySelector('#root > div > div');
  dom.style.height = `${window.innerHeight}px`;
}, 300);
